interface TopHeaderProps {
  collapsed: boolean;
  onToggle: () => void;
  user: { name: string } | null;
  onLogout: () => void;
}

export default function TopHeader({ collapsed, onToggle, user, onLogout }: TopHeaderProps) {
  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  return (
    <header className="admin-top-header">
      <div className="admin-top-header-left">
        <button className="admin-toggle-btn" onClick={onToggle} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
          {collapsed ? '☰' : '◀'}
        </button>
      </div>
      <div className="admin-top-header-right">
        <div className="admin-user-info">
          <div className="admin-user-avatar">{initials}</div>
          <span>{user?.name || 'Admin'}</span>
        </div>
        <button className="admin-logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}
